import { frontendURL } from '../../../helper/URLHelper';
import KanbanIndex from './Index.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_index',
      component: KanbanIndex,
      meta: commonMeta,
    },
  ],
};
